"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        width: 16,
        height: 16,
        boxShadow: '0 0 0 1px currentColor',
        '&::before': {
            content: '""',
            display: 'block',
            width: 'calc(100% - 4px)',
            height: 'calc(100% - 4px)',
            position: 'relative',
            top: 2,
            left: 2,
            backgroundColor: 'transparent'
        }
    },
    checked: {
        '&::before': {
            backgroundColor: 'currentColor'
        }
    },
    checkbox: {
        borderRadius: 2,
        '&::before': {
            borderRadius: 2
        }
    },
    radio: {
        borderRadius: '50%',
        '&::before': {
            borderRadius: '50%'
        }
    }
};
//# sourceMappingURL=checkbox.style.js.map